<template>

    <el-card class="property-card box-card" style="margin-bottom: 20px;">
        <div class="property-card__body">
            <div class="property-card__image" style="margin-right: 20px; width: 20%;">
                <el-image
                style="width: 100px; height: 100px"
                :src="property.survey_area_url"
                fit="fit"></el-image>
            </div>

            <div class="property-card__details">
                <p class="property-card__price">{{ property.land_price | priceFilter }}万円
                    <span class="property-card__price--discount" v-if="calcPriceMargin(property.property_logs)">( {{ calcPriceMargin(property.property_logs) | priceFilter }}万円 )</span>
                </p>
                <div class="property-card__dl-wrap">
                    <dl class="property-card__dl">
                        <dt class="property-card__dt">取得日時</dt>
                        <dd class="property-card__dd">{{ property.acquisition_date }}</dd>

                        <dt class="property-card__dt">住所</dt>
                        <dd class="property-card__dd">{{ property.address }}</dd>

                        <dt class="property-card__dt">土地面積</dt>
                        <dd class="property-card__dd">{{ property.land_area_squere | fixedFilter(2) }}（{{ property.land_area_unit }}坪）</dd>

                        <dt class="property-card__dt">最寄り駅</dt>
                        <dd class="property-card__dd">{{ property.closest_stations }}</dd>

                        <dt class="property-card__dt">駅距離</dt>
                        <dd class="property-card__dd">{{ property.distance }}m （徒歩{{ property.walk_minutes }}分）</dd>

                        <dt class="property-card__dt">接道道路幅員</dt>
                        <dd class="property-card__dd">{{ property.road_width | fixedFilterWidth(1) }}</dd>
                    </dl>
                    <dl class="property-card__dl">
                        <dt class="property-card__dt">容積率</dt>
                        <dd class="property-card__dd">{{ property.floor_area_ratio | toPercent }}%（{{ property.apply_floor_area_ratio | toPercent }}%）</dd>

                        <dt class="property-card__dt">一種単価</dt>
                        <dd class="property-card__dd">{{ property.unit_price | priceFilter }}万円（{{ property.apply_unit_price | priceFilter }}万円）</dd>

                        <dt class="property-card__dt">最大建築面積</dt>
                        <dd class="property-card__dd">{{ property.max_building_area | fixedFilter }}（{{ property.max_building_tsubo }}坪）</dd>

                        <dt class="property-card__dt">最大延床面積</dt>
                        <dd class="property-card__dd">{{ property.max_total_floor_area | fixedFilter }}（{{ property.max_total_floor_tsubo }}坪）</dd>

                        <dt class="property-card__dt">セットバック</dt>
                        <dd class="property-card__dd">{{ property.setback | setbackFilter}}</dd>
                    </dl>
                </div>
            </div>
            <a v-if="property.url" :href="property.url" target="_blank" class="property-card__link"></a>
            <a v-else @click="viewProperty" href="javascript:void(0)" class="property-card__link"></a>
        </div>
        <div class="property-card__sub">
                <el-table
                :data="tableData"
                style="width: 100%">

                <el-table-column
                    v-if="isAdmin"
                    fixed
                    prop="favorite"
                    label="公開状況">
                    <template slot-scope="scope">
                        <!-- scopeを外すとswitchがリアルタイムに動いてくれない -->
                        <el-switch
                            v-model="property.is_public"
                            @change="changePublicStatus(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else
                    fixed
                    prop="share"
                    label="シェアする">
                    <template slot-scope="scope">
                        <el-button type="info" icon="el-icon-share" circle @click="share(scope.row)"></el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="isAdmin"
                    fixed
                    prop="edit"
                    label="編集">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="primary" icon="el-icon-edit" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="property-card__favorite" v-if="isLoggedIn">
            <i :class="isFavorite === property.favorites ? 'el-icon-star-off' : 'el-icon-star-on'" @click="$emit('pushFavorite', property)"></i>
        </div>
    </el-card>
</template>

<script>
import { moneyFormatter } from '../../utils/formatter'
import { mapState } from 'vuex'

export default {
    props: {
        property: {
            type: Object
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
             tableData: [{
                 'favorite': ''
            }],
            value1: true,
            isFavorite: false,
            isDiscount: false
        }
    },

    computed: {
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn
        })
    },

    watch: {
        isAdmin: {
            handler() {
                this.isAdmin
            }
        }
    },

    filters: {
        priceFilter(price) {
            return moneyFormatter(price)
        },
        setbackFilter(value) {
            return value === 1 ? 'あり' : 'なし'
        },
        tsuboFilter(value) {
            let formatTsubo = Math.floor((value / 3.3333) * 100) / 100
            return formatTsubo.toFixed(2) + '坪'
        },
        // 小数点第○位まで表示
        // デフォルトは第２位
        fixedFilter(value, precision = 2) {
            if (value == null) {
                return '不明'
            }

            return value.toFixed(precision) + '㎡'
        },
        fixedFilterWidth(value, precision = 2) {
            if (value == null) {
                return '不明'
            }

            return value.toFixed(precision) + 'm'
        },
        toPercent(value) {
            if (value == null) {
                return '不明'
            }

            return value * 100
        }
    },

    methods: {
        viewProperty() {
            this.$emit('login')
        },
        changePublicStatus() {
            this.$emit('changePublicStatus', this.property)
        },
        share() {
            this.$emit('share', this.property)
        },
        edit() {
            this.$emit('edit', this.property)
        },

        // 物件のログ情報から値下げしているか判別して、している場合は値下げ幅を算出する
        calcPriceMargin(logs) {

            if (logs.length === 0) {
                return ''
            }

            const pastPrice = logs[0].land_price_numeric

            if (this.property.land_price < pastPrice) {
                return  this.property.land_price - pastPrice
            }

            return ''
        }
    }
}
</script>

<style lang="scss" scoped>

.property-card {
    position: relative;

    &__body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 3px solid #f7fafa;
        z-index: 1;

        & > a {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            text-indent:-999px;
            z-index: 2;
            transition: background-color .4s;

            &:hover {
                border: 3px solid #d7e7fc;
            }
        }
    }

    &__image {
        width: 25%;
        margin-right: 20px;
        flex-basis: 200px;
    }

    &__details {
        width: 85%;
    }

    &__price {
        text-align: left;
        color: #FF3F3A;
        font-weight: bold;
        font-size: 22px;

        &--discount {
            font-size: 16px;
        }
    }

    &__dl-wrap {
        display: flex;
    }

    &__dl {
        display:flex;
        flex-wrap: wrap;
        font-size: 13px;
    }

    &__dt {
        text-align: left;
        padding: 2px;
        width: 20%;
        box-sizing: border-box;
        font-size: 10px;
    }

    &__dd {
        text-align: left;
        padding: 2px;
        margin: 0;
        width: 80%;
        box-sizing: border-box;
    }

    &__link {
        display: block;
        font-size: 14px;
        text-align: right;
        padding: 5px;
    }

    &__favorite {
        position: absolute;
        top: 3px;
        right: 10px;
        padding: 10px;
        z-index: 5;
        font-size: 30px;

        &:hover {
            cursor: pointer;
            font-size: 30px;
        }

        &:active {
            font-size: 33px;
        }
    }
}

@media screen and (max-width: 800px) {
    .property-card {
        &__dl {
            font-size: 12px;
            margin-bottom: 0px;
        }

        &__dl-wrap {
            flex-direction: column;
        }
    }
}

@media screen and (max-width: 600px) {
    .property-card {
        &__details {
            flex-flow: column nowrap;
        }

        &__dl {
            font-size: 10px;
        }

        &__dd {
            width: 100%;
        }

        &__dt {
            width: 100%;
        }

        &__link {
            font-size: 12px
        }
    }
}
</style>

<style>
.el-checkbox__inner {
    width: 20px;
    height: 20px;
}

.el-checkbox__inner::after {
    left: 7px;
    top: 4px;
}

.el-icon-star-on {
    color: #FF3F3A;
}
</style>